export enum PostMessageSubscribeTypeEnum {
  DATA_CAPTURING = "data-capturing",
  ERROR = "error",
  SAVE_PROGRESS = "save-progress",
  RENDER_PREVIEW = "render-preview",
}
